import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { IHcpSwitchoverBatch, IHcpSwitchoverBlocked, IHcpSwitchoverCandidate, IHcpSwitchoverLegacyHcp } from '../../entities/hcpSwitchover/HcpSwitchover.ts';

export class HcpSwitchoverApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/HcpSwitchover`;

    public static apiUrls = {
        readiness: `${HcpSwitchoverApi.baseApiUrl}/Readiness`,
        legacyHcps: `${HcpSwitchoverApi.baseApiUrl}/LegacyHcps`,
        exclude: `${HcpSwitchoverApi.baseApiUrl}/:id/Exclude`,
        include: `${HcpSwitchoverApi.baseApiUrl}/:id/Include`,
        dryRun: `${HcpSwitchoverApi.baseApiUrl}/DryRun`,
        runBatch: `${HcpSwitchoverApi.baseApiUrl}/RunBatch`,
    };

    public static async getReadiness(): Promise<IHcpSwitchoverBlocked[]> {
        return this.sendApiRequest<IHcpSwitchoverBlocked[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.readiness,
        });
    }

    public static async getLegacyHcps(): Promise<IHcpSwitchoverLegacyHcp[]> {
        return this.sendApiRequest<IHcpSwitchoverLegacyHcp[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.legacyHcps,
        });
    }

    public static async setExcluded(id: number, excluded: boolean): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.POST,
            path: excluded ? this.apiUrls.exclude : this.apiUrls.include,
            id: id.toString(),
        });
    }

    public static async dryRun(data: IHcpSwitchoverBatch): Promise<IHcpSwitchoverCandidate[]> {
        return this.sendApiRequest<IHcpSwitchoverCandidate[]>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.dryRun,
            data: data,
        });
    }

    public static async runBatch(data: IHcpSwitchoverBatch): Promise<IHcpSwitchoverCandidate[]> {
        return this.sendApiRequest<IHcpSwitchoverCandidate[]>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.runBatch,
            data: data,
        });
    }
}
